import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { RightPanel } from "./rightPanel/RightPanel";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { manufacturingStagesListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery, useToggle } from "hooks";
import { useState } from "react";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { ListHeader } from "./components/ListHeader";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";
import { useManufacturingStages } from "api/manufacturingNew/hooks";
import { CreateManufacturingStageModal } from "./components/CreateManufacturingStageModal";

export const ManufacturingStagesList = () => {
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query });
  const createManufacturingStageModal = useToggle(false);
  const { data: manufacturingStages, error, isLoading, pagination } = useManufacturingStages(
    search,
  );
  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !manufacturingStages.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader open={createManufacturingStageModal.open} />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="manufacturing" />
        <ListHeader open={createManufacturingStageModal.open} />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID | number,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      manufacturingStages,
    );
  };

  return (
    <div className="pageContainer">
      <ListHeader open={createManufacturingStageModal.open} />
      <RightPanelHandler name="manufacturingStagesList">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="zamówienia" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={manufacturingStagesListConfig.grid}
                  labels={manufacturingStagesListConfig.labels}
                />
                <ModuleListBody>
                  {manufacturingStages.map((manufacturingStage, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={manufacturingStage.id}
                      manufacturingStage={manufacturingStage}
                      selectMutlipleItems={selectMutlipleItems}
                      togglePanel={togglePanel}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            <RightPanel close={close} />
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
      {createManufacturingStageModal.isOpen && (
        <CreateManufacturingStageModal close={createManufacturingStageModal.close} />
      )}
    </div>
  );
};
